export default __webpack_public_path__ + "static/media/maisons_laffitte7.485c5627.jpg";